export default "__VITE_ASSET__da961756__"